import React from "react";
import BCGlobalStore from "./BCGlobalStore";
import LMSStore from "./lms/LmsGlobalStore";
import BCGlobalCacheStore from "./BCGlobaleCacheStore";
import BCGlobalMetadataStore from "./BCGlobalMetadata";

const BCStoresWrapper = ({ children }) => {
  return <BCGlobalCacheStore>
    <BCGlobalMetadataStore>
      <BCGlobalStore>
        <LMSStore>{children}</LMSStore>
      </BCGlobalStore>
    </BCGlobalMetadataStore>
  </BCGlobalCacheStore>;
};

export default BCStoresWrapper;
